import React from 'react';

import ErrorComponent from '../generic/Error';
import Loading from '../generic/Loading';
import { tapFlashError, tapFlashSuccess } from '../utils/flash';
import getDisplayName from '../utils/get-display-name';
import RequestComponent from './RequestComponent';

export default function withApiRequest({
  query: queryFn,
  error: errorHandling = 'render',
  renderLoading = false,
  successMessage = '',
}) {
  return WrappedComponent => {
    class WithApiRequestComponent extends RequestComponent {
      constructor(props) {
        super(props);

        this.handleRequest = this.handleRequest.bind(this);
      }

      handleRequest(...queryArgs) {
        const queryPromise = queryFn(...queryArgs);
        if (successMessage) {
          queryPromise.then(tapFlashSuccess(successMessage));
        }
        if (errorHandling === 'flash') {
          queryPromise.catch(tapFlashError());
        }
        return this.trackRequest(queryPromise);
      }

      render() {
        const { request, error, result } = this.state;
        return (
          <>
            {renderLoading && this.isLoading() && <Loading className="px-0" />}
            {errorHandling === 'render' && error && (
              <ErrorComponent error={error} />
            )}
            <WrappedComponent
              onRequest={this.handleRequest}
              response={result}
              error={error}
              loading={!!request}
              {...this.props}
            />
          </>
        );
      }
    }

    WithApiRequestComponent.displayName = `withApiRequest(${
      queryFn.name
    } for ${getDisplayName(WrappedComponent)})`;

    return WithApiRequestComponent;
  };
}
